export default class User
{
    constructor(id, name, description, username, active){
        this.id                 = id ?? 0
        this.name               = name
        this.description        = description
        this.username           = username
        this.active             = active
    }
}